
import { defineComponent, computed, PropType } from 'vue'
import { useRouter } from 'vue-router'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import Button from '@/components/elements/Button.vue'
import HomeRecommendSpecialCard from '@/components/block/HomeRecommendSpecialCard.vue'
import type { MagazineSpecialRecommendContent } from '@/types/MagazineRecommend'

export default defineComponent({
  name: 'HomeRecommendSpecial',

  components: {
    HomeRecommendSpecialCard,
    HeadingLv2,
    Button
  },

  props: {
    contents: {
      type: Array as PropType<MagazineSpecialRecommendContent[]>,
      default: () => []
    }
  },

  setup(props) {
    const router = useRouter()
    const displayContents = computed(() => props.contents.slice(0, 12))

    const cropText = (text: string) => {
      return text.length > 30 ? text.substr(0, 30) + '…' : text
    }

    const moveToSpecialIndex = () => {
      router.push(`/magazines/special`)
    }

    return {
      displayContents,
      cropText,
      moveToSpecialIndex
    }
  }
})
